<script setup lang="ts">
import { onMounted } from 'vue'
interface Props {
  text?: string
}
defineProps<Props>()

onMounted(() => {
  if (!document.querySelector('script[src="https://cdn.lordicon.com/lordicon.js"]')) {
    const script = document.createElement('script')
    script.src = 'https://cdn.lordicon.com/lordicon.js'
    document.head.appendChild(script)
  }
})
</script>

<template>
  <div class="flex flex-col gap-6 items-center justify-center w-full h-screen">
  <lord-icon
    src="https://cdn.lordicon.com/tewlfgbl.json"
    trigger="loop"
    state="loop-expand"
    colors="primary:#2563eb"
    style="width: 90px; height: 90px"
  />
  <p class="text-md text-gray-500">{{ text || $t('loading') }}</p>
</div>
</template>
